import { render, staticRenderFns } from "./GestorCentralizadoTab.vue?vue&type=template&id=1efbf7f6&"
import script from "./GestorCentralizadoTab.vue?vue&type=script&lang=js&"
export * from "./GestorCentralizadoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports